import { ConfigBuilder } from '../config-builder'

const baseConfig = new ConfigBuilder({
  tailwind: true
}).build()
export default baseConfig
